module.exports = __webpack_public_path__ + "img/message.b0534195.svg";